import { PreLaunch } from "./../../services/pre_launch";

// Representação central do Modo Pré-Lançamento. Nenhum componente deve
// consultar o backend por conta própria nem decidir bloqueio sozinho: quem
// decide é o PreLaunchGuard do router, lendo o getter `blocking` daqui.
//
// O frontend NÃO é fonte de verdade: `hasAccess` vem sempre do backend
// (bootstrap público, resposta de login ou resposta de cadastro).
export const state = {
  enabled: false,
  hasAccess: true,
  message: null
};

export const getters = {
  preLaunchEnabled(state) {
    return state.enabled;
  },

  currentUserHasAccess(state) {
    return state.hasAccess;
  },

  preLaunchMessage(state) {
    return state.message;
  },

  // Barreira funcional: modo ligado e usuário atual fora do snapshot.
  blocking(state) {
    return state.enabled && !state.hasAccess;
  }
};

export const mutations = {
  SET_PRE_LAUNCH(state, payload) {
    const status = payload || {};

    state.enabled = status.enabled === true;
    state.hasAccess = status.has_access !== false;
    state.message = status.message || null;
  }
};

export const actions = {
  // Bootstrap: uma chamada por carregamento da aplicação.
  fetchStatus({ commit }) {
    return PreLaunch.status()
      .then(response => {
        commit("SET_PRE_LAUNCH", response.data);
        return response.data;
      })
      .catch(() => {
        // Sem status confiável o cliente não bloqueia — o backend continua
        // sendo a fonte de verdade e responde 403 quando for o caso.
        commit("SET_PRE_LAUNCH", null);
        return null;
      });
  },

  // Usado com o nó `pre_launch` que vem nas respostas de login e de cadastro,
  // evitando uma chamada extra logo depois de autenticar.
  setStatus({ commit }, payload) {
    commit("SET_PRE_LAUNCH", payload);
  },

  // Rede de segurança: o backend respondeu 403 pre_launch_blocked no meio da
  // sessão (o gestor ativou o modo depois que a aplicação carregou).
  markBlocked({ commit, state }, message) {
    commit("SET_PRE_LAUNCH", {
      enabled: true,
      has_access: false,
      message: message || state.message
    });
  }
};
